import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
// Components across the app
import { QbInputModule } from '@fwmovilidad/qb-lib-ng-components';
import { QbClientDataComponent } from './client-data.component';
import { MatDialogModule } from '@angular/material/dialog';
import { IonicModule } from '@ionic/angular';

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    QbInputModule,
    MatDialogModule,
  ],
  declarations: [
    QbClientDataComponent,
  ],
  exports: [
    QbClientDataComponent,
  ],
})
export class ClientDataPageModule { }
